function SuggestController() {

    this.init = function () {

        jQuery('form[data-suggest]').each(function () {
            var $form = $(this), $searchBox = $form.find('.tx-solr-suggest'), $formAutoComplete;

            if ($form.find('.tx-solr-autocomplete').length > 0){
                $formAutoComplete = $form.find('.tx-solr-autocomplete');
            } else {
                $formAutoComplete = $('body');
            }

            // when no specific container found, use the form as container
            if ($searchBox.length === 0) {
                $searchBox = $form;
            }
            $searchBox.css('position', 'relative');

            $form.find('.tx-solr-suggest-focus').focus();

            // Prevent submit of empty search form
            $form.on('submit', function (e) {
                if ($form.find('.tx-solr-suggest-focus').val() === '') {
                    e.preventDefault();
                    $form.find('.tx-solr-suggest-focus').focus();
                }
            });

            $form.find('.tx-solr-suggest').devbridgeAutocomplete({
                serviceUrl: $form.data('suggest'),
                dataType: 'json',
                paramName: 'tx_solr[queryString]',
                groupBy: 'category',
                maxHeight: 1000,
                appendTo: $formAutoComplete,
                autoSelectFirst: false,
                triggerSelectOnValidInput: false,
                width: $searchBox.outerWidth() * 0.66,
                onSelect: function (suggestion) {
                    // go to link when selecting found result
                    if (suggestion.data.link) {
                        // Open youtube in overlay
                        if (suggestion.data.link.indexOf('https://www.youtube.com') === 0) {
                            openVideoOverlay(suggestion.data.link);
                        } else {
                            location.href = suggestion.data.link;
                        }
                        // else trigger form submit (do search)
                    } else {
                        $form.trigger('submit');
                    }
                },
                transformResult: function (response) {
                    if (!response.suggestions) return {suggestions: []};
                    var firstSuggestion, result = {
                        suggestions: $.map(response.suggestions, function (count, suggestion) {
                            if (!firstSuggestion) firstSuggestion = suggestion;
                            return {value: suggestion, data: {category: 'suggestion', count: count}};
                        })
                    };

                    $.each(response.documents, function (key, value) {
                        var dataObject = value;

                        var defaultGroup = $form.data('suggest-header') ? $form.data('suggest-header') : 'Top results';
                        dataObject.category = defaultGroup;

                        // if a group is set we try to get a label
                        if(dataObject.group) {
                            dataObject.category = $form.data('suggest-header-' + dataObject.group) ? $form.data('suggest-header-' + dataObject.group) : dataObject.group;
                        }

                        result.suggestions.push(
                            {
                                value: firstSuggestion,
                                data: dataObject
                            }
                        );
                    });

                    return result;
                },
                beforeRender: function (container) {
                    // remove first group header
                    container.find('.autocomplete-group:first').remove();
                    container.addClass('tx-solr-autosuggest');
                    container.addClass('bg-white');
                    container.addClass('border-t');
                    container.addClass('border-b');
                    container.addClass('border-l');
                    container.addClass('border-r');
                    container.addClass('border-bleAkzentfarbe-darkgreen');
                    container.addClass('-mt-px');
                    container.addClass('flex');
                    container.addClass('flex-col');
                    container.addClass('items-start');
                    container.addClass('p-2.5');

                    container.find('.autocomplete-suggestion').each(function () {
                        $(this).attr('role', 'option');
                    })
                    container.find('.autocomplete-group').each(function () {
                        $(this).attr('role', 'presentation');
                    })

                    var topSearch = container.find('.autocomplete-group');
                    topSearch.addClass('py-bundPadding-5px w-full');
                    topSearch.html('<p class="before:border-b before:border-bundFarben-hellgrau1 before:inset-x-0 before:absolute before:top-1/2 before:content-[\'\'] text-center relative"><span class="!inline-block bg-white relative px-bundPadding-5px"><i class="far fa-thumbs-up" aria-hidden="true"></i> <span class="uppercase">' + topSearch.text() + '</span></span></p>');

                    // add active class to container
                    $searchBox.parent().addClass('autocomplete-active').fadeIn();
                },
                formatResult: function (suggestion, currentValue) {
                    // Do not replace anything if there current value is empty
                    if (!currentValue) {
                        return suggestion.value;
                    }
                    var pattern = '(' + $.Autocomplete.utils.escapeRegExChars(currentValue.trim()) + ')';
                    // normal suggestion
                    if (suggestion.data.category === 'suggestion') {
                        return suggestion.value
                            .replace(new RegExp(pattern, 'gi'), '<strong>$1<\/strong>')
                            .replace(/&/g, '&amp;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;')
                            .replace(/"/g, '&quot;')
                            .replace(/&lt;(\/?strong)&gt;/g, '<$1>');

                        // results
                    } else {
                        var title = suggestion.data.title
                            .replace(new RegExp(pattern, 'gi'), '<em>$1<\/em>')
                            .replace(/&/g, '&amp;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;')
                            .replace(/"/g, '&quot;')
                            .replace(/&lt;(\/?em)&gt;/g, '<$1>');

                        var type = suggestion.data.type;
                        var tel = suggestion.data.orgaTelefon_stringS;
                        if (tel) {
                            tel = ', <span class="bund-text-color-hellgrau1">' + tel + '</span>';
                        }
                        var organisationseinheit = suggestion.data.orgaNummer_stringS;
                        if (type === 'pages') {
                            title = '<i class="fas fa-file-alt fa-fw pr-2" aria-hidden="true"></i>' + title;
                        }
                        if (type === 'tx_news_domain_model_news') {
                            title = '<i class="fas fa-newspaper fa-fw pr-2" aria-hidden="true"></i>' + title;
                        }
                        if (type === 'sys_file_metadata') {
                            var filename = suggestion.data.link.split("/").pop();
                            title = '<i class="fas fa-download fa-fw pr-2" aria-hidden="true"></i>' + filename;
                        }
                        if (type === 'tx_glossaryone_domain_model_term') {
                            title = '<i class="fas fa-book fa-fw pr-2" aria-hidden="true"></i>&nbsp' + title;
                        }
                        if (type === 'tx_bletelefonbuch_domain_model_telefonbuch') {
                            title = '<i class="fas fa-phone fa-fw pr-2" aria-hidden="true"></i>' + title;
                        }
                        if (type === 'tx_bleinformprojekte_domain_model_projekte') {
                            title = '<i class="far fa-list-alt fa-fw pr-2" aria-hidden="true"></i>' + title;
                        }

                        return '<div class="' + suggestion.data.type + '">' +
                            (!!suggestion.data.previewImage ? '<figure ' + (!!suggestion.data.hasVideo ? 'class="hasVideo"' : '') + '><img src="' + suggestion.data.previewImage + '" /></figure>' : '') +
                            '<a href="' + suggestion.data.link + '" class="internal-link">' + title + '</a>' +
                            '</div>';
                    }

                }
            }).on('blur', function () {
                $searchBox.parent().removeClass('autocomplete-active');
                var $box = $(this);
                setTimeout(function () {
                    $box.devbridgeAutocomplete('hide');
                }, 200);
            });
        });
    };
}

jQuery(document).ready(function() {
    /** solr search autocomplete **/
    var solrSuggestController = new SuggestController();
    solrSuggestController.init();
    jQuery("body").on("tx_solr_updated", function() {
        solrSuggestController.init();
    });

    var SolrTopSearch = $('#topsearch-field');
    var SolrMainSearch = $('#search-field');

    $('div.autocomplete-suggestions').attr('role', 'listbox');

    SolrTopSearch.focus(function () {
        $('div.autocomplete-suggestions').outerWidth($('input#topsearch-field').outerWidth() + 'px');
    });

    SolrMainSearch.focus(function () {
        $('div.autocomplete-suggestions').outerWidth($('input#search-field').outerWidth() + 'px');
    });

});
